<template>
  <div class="subcat-score-column-wrapper">
    <subcat-row v-for="(subcategory, index) in subcategories" 
      :key="subcategory.name"
      :subcategory="subcategory"
      :subcatColumnA="columnAsubcats[index]"
      :subcatColumnB="columnBsubcats[index]">
      </subcat-row>
  </div>
</template>

<script>
import CurrentSubcatRow from './CurrentSubcatRow';

export default {
  name: 'subcategory-scores',
  props: ['subcategories', 'columnAsubcats', 'columnBsubcats'],
  components: {
    'subcat-row': CurrentSubcatRow,
  },
};
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// SubcategoryScores.vue?6a04b2d2